// extracted by mini-css-extract-plugin
module.exports = {"icon-warning":"icon-warning___11fJY","title":"title___1foIB"};